import React from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
// import RadioButton from './RadioButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/joy/Grid';
import Stack from '@mui/joy/Stack';

interface Props {
  id?: string;
  hidden?: boolean;
  name?: string;
  values?: any;
  onChange?: any;
  options: any[];
  mdCol?: number;
  disabled?: boolean;
  className?: string;
  label?: string;
  hiddenFormLabel?: boolean;
  onClear?: any;
  logo?: string;
  helperText?: string;
  isMissing?: any;
  justifyContent?: string;
  verticalLayout?: boolean;
  columns?: number;
  gridGap?: any;
}

const GroupRadioButton = (props: Props) => {
  const handleClear = () => {
    props.onClear && props.onClear();
  };
  
  let gridGap = {};
  if (props.gridGap!==undefined) {
    gridGap =  { gap: `${props.gridGap}`};
  }
  return props.hidden ? null : (
    <div
      className={props.className}
      style={{
        //gap: '16px',
        //padding: '5px',
        border: props.isMissing ? '1px solid #DC2626' : 'none',
        borderRadius: '8px',
        backgroundColor: props.isMissing ? '#FEF2F2' : 'transparent',
      }}
    >
      {props.label && (props.hiddenFormLabel === undefined || props.hiddenFormLabel === false) && (
        <FormLabel
          className={`label-14px pb-1 ${props.logo ?? ''}`.trim()}
          sx={{
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
            fontSize: '14px',
            mb: 1,
            display: 'block',
            fontWeight: 600,
            color: '#374151',
          }}
        >
          {props.label}
        </FormLabel>
      )}

      {props.helperText && (
        <FormHelperText sx={{ fontSize: '12px', color: '#6B7280' }}>
          {props.helperText}
        </FormHelperText>
      )}

      <Stack direction="column" spacing={0.5}>
        <RadioGroup
          name={props.name}
          value={props.values ?? ''}
          onChange={props.onChange}
        >
          <Grid container rowSpacing={0.5} justifyContent={props.justifyContent || 'flex-start'}
            sx={gridGap}
          >
            {(props.options || []).map((opt, index) => (
              <Grid
                xs={12}
                md={props.columns ? 12 / props.columns : props.verticalLayout ? 12 : 'auto'}
                sx={{padding:'0px!important'}}
              >
                <FormControlLabel
                  value={opt?.value || opt}
                  control={
                    <Radio
                      size="medium"
                      sx={{
                        // paddingLeft: 0,
                        // paddingRight: '8px',
                        color: props.isMissing ? '#DC2626' : '#3B82F6',
                        padding: '7px 9px',
                        '&.Mui-checked': {
                          color: props.isMissing ? '#DC2626' : '#3B82F6',
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(59, 130, 246, 0.04)',
                        },
                      }}
                    />
                  }
                  label={opt?.label || opt?.value || opt}
                  disabled={props.disabled}
                  sx={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    alignItems: 'flex-start',
                    margin: 0,
                    '& .MuiFormControlLabel-label': {
                      fontSize: '14px',
                      color: '#374151',
                      lineHeight: '1.4',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere',
                    },
                    '& .MuiRadio-root': {
                      margin: 0,
                      paddingTop: '4px',
                    },
                  }}
                />
                {opt?.extendElement && opt?.value === props.values && <>{opt?.extendElement}</>}
              </Grid>
            ))}
          </Grid>
        </RadioGroup>

        {props.onClear && (
          <Row>
            <Col md={props.mdCol || 3}>
              <Badge 
                bg="light" 
                text="dark" 
                className="pointer" 
                onClick={props.disabled ? undefined : handleClear}
                style={{
                  backgroundColor: props.disabled ? '#F5F5F5' : '#E3F2FD',
                  color: props.disabled ? '#9E9E9E' : '#1976D2',
                  border: props.disabled ? '1px solid #E0E0E0' : '1px solid #BBDEFB',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: props.disabled ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'inline-block',
                  marginTop: '8px',
                  opacity: props.disabled ? 0.6 : 1,
                }}
                onMouseEnter={props.disabled ? undefined : (e) => {
                  const target = e.target as HTMLElement;
                  target.style.backgroundColor = '#BBDEFB';
                  target.style.color = '#1565C0';
                }}
                onMouseLeave={props.disabled ? undefined : (e) => {
                  const target = e.target as HTMLElement;
                  target.style.backgroundColor = '#E3F2FD';
                  target.style.color = '#1976D2';
                }}
              >
                Clear
              </Badge>
            </Col>
          </Row>
        )}
      </Stack>

      {props.isMissing && (
        <FormHelperText sx={{ color: '#DC2626', fontSize: '12px' }}>
          This field is required.
        </FormHelperText>
      )}
    </div>
  );
};

export default GroupRadioButton;
